import styled from "@emotion/styled";
import { Container } from "react-bootstrap";
import { IStyledComponentProps } from "../../../theme/theme.types";

const PaginationContainer = styled(Container)<IStyledComponentProps>`
  &.pagination-container {
    @media (max-width: ${(props) =>
        props.theme.utils.getThemeBreakpoint("tablet")}) {
      display: flex;
      justify-content: center;
    }

    padding-left: 12px;
    .page-item {
      &.disabled {
        .page-link {
          background-color: ${({ theme }) => theme.colors.grays.senary};
        }
      }
    }
  }
`;

export default { PaginationContainer };
